// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90035992","389":"7a8b8798","453":"4d64781d","455":"1a18bcbb","977":"5dbca6f3"}[chunkId] + ".chunk.js";
};